module.exports = __webpack_public_path__ + "img/baamtu_logo.979ba0ac.jpeg";